export function interpolate (message: string, values: any, mode: string = 'string'): any {
  if (!values || typeof message !== 'string') {
    return message;
  }
  let tokens: Array<Token> = parse(message);
  const ret = compile(tokens, values);
  return mode === 'string' && typeof ret !== 'string' ? ret.join('') : ret
}

type Token = {
  type: 'text' | 'named' | 'list' | 'unknown',
  value: string
}

function isObject (obj: any) {
  return obj !== null && typeof obj === 'object';
}

const RE_TOKEN_LIST_VALUE: RegExp = /^(?:\d)+/;
const RE_TOKEN_NAMED_VALUE: RegExp = /^(?:\w)+/;

function parse (format: string): Array<Token> {
  format = trimStr(format);

  const tokens: Array<Token> = [];
  let position: number = 0;

  let text: string = '';
  while (position < format.length) {
    let char: string = format[position++];
    if (char === '{') {
      if (text) {
        tokens.push({ type: 'text', value: text });
      }

      text = '';
      let sub: string = '';
      char = format[position++];
      while (char !== undefined && char !== '}') {
        sub += char;
        char = format[position++];
      }
      const isClosed = char === '}';

      const type = RE_TOKEN_LIST_VALUE.test(sub)
        ? 'list'
        : isClosed && RE_TOKEN_NAMED_VALUE.test(sub)
          ? 'named'
          : 'unknown';
      tokens.push({ value: sub, type });
    } else if (char === '%') {
      // when found rails i18n syntax, skip text capture
      if (format[(position)] !== '{') {
        text += char;
      }
    } else {
      text += char;
    }
  }

  text && tokens.push({ type: 'text', value: text });
  return tokens;
}

function compile (tokens: Array<Token>, values: Object | Array<any>): Array<any> {
  const compiled: Array<any> = [];
  let index: number = 0;

  const mode: string = Array.isArray(values)
    ? 'list'
    : isObject(values)
      ? 'named'
      : 'unknown';
  if (mode === 'unknown') { return compiled; }

  while (index < tokens.length) {
    const token: Token = tokens[index];
    switch (token.type) {
      case 'text':
        compiled.push(token.value);
        break;
      case 'list':
        compiled.push((values as any)[parseInt(token.value, 10)]);
        break;
      case 'named':
        if (mode === 'named') {
          compiled.push((values as any)[token.value]);
        }
        break;
      case 'unknown':
        console.warn(`Detect 'unknown' type of token!`);
        break;
    }
    index++;
  }

  return compiled;
}

// 去除翻译里面的多余花括号，已经花括号内的空格
function trimStr(str: string) {
  if (!str) {
    return str;
  }
  const reg3 = /{{{\s*(.*?)\s*}}}/g;
  const reg2 = /{{\s*(.*?)\s*}}/g;
  str = str.replace(reg3, (m, n) => '{' + n + '}');
  str = str.replace(reg2, (m, n) => '{' + n + '}');

  return str;
}
